// Presentation only. Never infer purity, batch identity, stock, or physical
// contents from a name/SKU. Unknown formats keep their exact specification.
export function productPresentation(product = {}) {
  const specification = String(product.specification || '').trim();
  const vialPack = specification.match(/^(.+?)\s*[x×]\s*(\d+)\s*vials?\s*$/i);
  const capsuleProduct = /capsules?/i.test(`${product.name || ''} ${product.category || ''}`);
  const capsulePack = capsuleProduct && specification.match(/^(.+?)\s*[x×]\s*(\d+)(?:\s*capsules?)?\s*$/i);
  const pack = vialPack || capsulePack;
  if (!pack || Number(pack[2]) <= 0) {
    return { kind: 'specification', strength: specification || 'Specification not supplied', count: null, packLabel: 'Listed unit' };
  }
  const count = Number(pack[2]);
  return {
    kind: vialPack ? 'vials' : 'capsules',
    strength: pack[1].trim(),
    count,
    packLabel: `${count} ${vialPack ? (count === 1 ? 'vial' : 'vials') : (count === 1 ? 'capsule' : 'capsules')}`,
  };
}
